import React, {Component} from 'react';
import classes from './ToolTip.css';

class ToolTip extends Component {

    state = {
        showMessage: false
    };

    mouseEnter = () => {
        let newState = Object.assign({}, this.state);
        newState.showMessage = true;
        this.setState(newState);
    };

    mouseLeave = () => {
        let newState = Object.assign({}, this.state);
        newState.showMessage = false;
        this.setState(newState);
    };

    render() {
        let messageDiv = null;

        if (this.state.showMessage) {
            if (this.props.includeHtmlTag) {
                messageDiv = (
                    <div className={classes.message} dangerouslySetInnerHTML={{__html: this.props.message}} />
                );
            } else {
                messageDiv = (
                    <div className={classes.message}>{this.props.message}</div>
                );
            }
        }

        return (
            <div className={classes.ToolTip}>
                <div
                    className={classes.icon}
                    onMouseEnter={this.mouseEnter}
                    onMouseLeave={this.mouseLeave}
                >
                    <i className="fas fa-question-circle"></i>
                </div>
                {messageDiv}
            </div>
        );
    }
}

export default ToolTip;


// WEBPACK FOOTER //
// ./src/containers/ToolTip/ToolTip.js